export default __webpack_public_path__ + "static/media/myobToNeto.419392ac.png";